export enum OrderStatus {
    IN_PROGRESS = "IN_PROGRESS",
    PENDING = "PENDING",
    OFFER = "OFFER",
    ORDER = "ORDER",
    EXECUTION = "EXECUTION",
    DONE = "DONE",
    REJECTED = "REJECTED"
}